function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.6946 24.6579L17.9509 1.11404C17.5437 0.41645 16.8144 0 16 0C15.1856 0 14.4563 0.41645 14.0491 1.11404L0.305438 24.6579C-0.101812 25.3555 -0.101812 26.1884 0.305438 26.886C0.712625 27.5836 1.44194 28 2.25638 28H29.7436C30.5581 28 31.2874 27.5836 31.6946 26.886C32.1018 26.1884 32.1018 25.3555 31.6946 24.6579ZM30.0688 25.9576C30.0284 26.027 29.9322 26.1433 29.7437 26.1433H2.25638C2.06775 26.1433 1.97162 26.027 1.93125 25.9576C1.89081 25.8883 1.83694 25.7478 1.93125 25.5863L15.6748 2.04238C15.7691 1.88086 15.919 1.85669 15.9999 1.85669C16.0809 1.85669 16.2308 1.88079 16.3251 2.04238L30.0688 25.5863C30.1631 25.7478 30.1093 25.8883 30.0688 25.9576Z",
  fill: "#DC1A1A"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.939 8.44249H15.0617V18.3451H16.939V8.44249Z",
  fill: "#DC1A1A"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.0003 22.6776C16.6915 22.6776 17.2519 22.1234 17.2519 21.4397C17.2519 20.7561 16.6915 20.2019 16.0003 20.2019C15.3091 20.2019 14.7487 20.7561 14.7487 21.4397C14.7487 22.1234 15.3091 22.6776 16.0003 22.6776Z",
  fill: "#DC1A1A"
});

const SvgWarning = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.6e90f10e.svg";
export { ForwardRef as ReactComponent };